"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadAuditPdfButton = void 0;
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var c = (0, BemBuilder_1.default)("download-pdf");
var MAX_TRIES = 10;
var INTERVAL = 3000;
var BUTTON_TIMEOUT = 1000;
var TOOLTIP_TIMEOUT = 3000;
var DownloadAuditPdfButton = (function (_super) {
    __extends(DownloadAuditPdfButton, _super);
    function DownloadAuditPdfButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pollTimeout = null;
        _this.resetButtonStateTimeout = null;
        _this.hideTooltipTimeout = null;
        _this.pollCounter = 0;
        _this.buttonState = kaleidoscope_1.ButtonState.Idle;
        _this.showTooltip = false;
        _this.isPdfReady = function () { return __awaiter(_this, void 0, void 0, function () {
            var auditTrailPdfUrl, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        auditTrailPdfUrl = this.props.acceptData.auditTrailPdfUrl;
                        return [4, fetch(auditTrailPdfUrl)];
                    case 1:
                        res = _a.sent();
                        return [2, res.status === 200];
                }
            });
        }); };
        _this.endPolling = function () {
            if (_this.pollTimeout) {
                clearTimeout(_this.pollTimeout);
                _this.pollTimeout = null;
            }
            _this.pollCounter = 0;
        };
        _this.pollPdfUrl = function () {
            if (_this.pollCounter < MAX_TRIES) {
                _this.buttonState = kaleidoscope_1.ButtonState.Waiting;
                _this.pollTimeout = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                    var ready;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, this.isPdfReady()];
                            case 1:
                                ready = _a.sent();
                                if (ready) {
                                    this.endPolling();
                                    this.downloadPdf();
                                }
                                else {
                                    this.pollCounter++;
                                    this.pollPdfUrl();
                                }
                                return [2];
                        }
                    });
                }); }, INTERVAL);
            }
            else {
                _this.buttonState = kaleidoscope_1.ButtonState.Idle;
                _this.endPolling();
            }
        };
        _this.handleClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var isPreviewMode, isPolling;
            var _this = this;
            return __generator(this, function (_a) {
                isPreviewMode = this.props.isPreviewMode;
                isPolling = this.pollTimeout !== null;
                if (isPreviewMode) {
                    this.showTooltip = true;
                    this.hideTooltipTimeout = setTimeout(function () {
                        _this.showTooltip = false;
                    }, TOOLTIP_TIMEOUT);
                }
                else if (!isPolling) {
                    this.pollPdfUrl();
                }
                return [2];
            });
        }); };
        return _this;
    }
    DownloadAuditPdfButton.prototype.componentWillUnmount = function () {
        this.endPolling();
        if (this.resetButtonStateTimeout) {
            clearTimeout(this.resetButtonStateTimeout);
        }
        if (this.hideTooltipTimeout) {
            clearTimeout(this.hideTooltipTimeout);
        }
    };
    DownloadAuditPdfButton.prototype.downloadPdf = function () {
        var _this = this;
        var _a = this.props, auditTrailPdfUrl = _a.acceptData.auditTrailPdfUrl, onDownloaded = _a.onDownload;
        window.open(auditTrailPdfUrl);
        this.buttonState = kaleidoscope_1.ButtonState.Success;
        onDownloaded();
        this.resetButtonStateTimeout = setTimeout(function () {
            _this.buttonState = kaleidoscope_1.ButtonState.Idle;
        }, BUTTON_TIMEOUT);
    };
    DownloadAuditPdfButton.prototype.render = function () {
        var _a = this.props, esignEnabled = _a.esignEnabled, isPreviewMode = _a.isPreviewMode, auditTrailPdfUrl = _a.acceptData.auditTrailPdfUrl;
        var showButton = isPreviewMode || !!auditTrailPdfUrl;
        if (!showButton) {
            return null;
        }
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c()) },
            react_1.default.createElement(kaleidoscope_1.Tooltip, { show: this.showTooltip, content: "PDF download is not available for Preview Accept Mode", size: kaleidoscope_1.TooltipSize.Large },
                react_1.default.createElement(kaleidoscope_1.Button, { width: "full", type: kaleidoscope_1.ButtonType.Secondary, className: c("button"), onClick: this.handleClick, buttonState: this.buttonState },
                    react_1.default.createElement(icons_1.Download, null), "Download ".concat(esignEnabled ? "signed" : "accepted", " PDF")))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], DownloadAuditPdfButton.prototype, "buttonState", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], DownloadAuditPdfButton.prototype, "showTooltip", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DownloadAuditPdfButton.prototype, "endPolling", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DownloadAuditPdfButton.prototype, "pollPdfUrl", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DownloadAuditPdfButton.prototype, "handleClick", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DownloadAuditPdfButton.prototype, "downloadPdf", null);
    DownloadAuditPdfButton = __decorate([
        mobx_react_1.observer
    ], DownloadAuditPdfButton);
    return DownloadAuditPdfButton;
}(react_1.default.Component));
exports.DownloadAuditPdfButton = DownloadAuditPdfButton;
